var _defs, _path, _polyline, _path2, _path3, _path4, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDischargeLamp2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FFFFFF;}.cls-1,.cls-2{fill: #FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;stroke-width:0.5px;}\n"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discharge Lamp#2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.13,13.41v-4a7.88,7.88,0,0,1,15.76,0v4H14v-4a6,6,0,0,0-12,0v4Z",
    transform: "translate(-0.01 0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "7.38 1.52 7.97 0.28 8.63 1.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.13,11.75H15.89V10.37H.13Z",
    transform: "translate(-0.01 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.13,13.41a1,1,0,0,1-1.06.87A1,1,0,0,1,0,13.41",
    transform: "translate(-0.01 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,13.41a1.09,1.09,0,0,1-1.31.81,1.11,1.11,0,0,1-.81-.81",
    transform: "translate(-0.01 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.06,
    y1: 14.25,
    x2: 1.06,
    y2: 16.28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.93,
    y1: 14.25,
    x2: 14.93,
    y2: 16.28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.01,
    y1: 11.06,
    x2: 8.01,
    y2: 16.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargeLamp2);
export default __webpack_public_path__ + "static/media/DischargeLamp2.eceb0b964459c6a06c38d2c43b982d1e.svg";
export { ForwardRef as ReactComponent };